import { z } from "zod";
export const ElementPropertyValue = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    targetElementPersistentId: z.string(),
    definitionPersistentId: z.string(),
    stringValue: z.string().nullish(),
    numberValue: z.number().nullish(),
    booleanValue: z.boolean().nullish(),
    referenceValue: z.string().nullish(),
    referenceValuePreview: z.string().optional(),
});
